var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlideSidebarContainer',[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Histórico de cursos")]),_c('CourseHistoryList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }